<template>
	<div>
		


		<panel class="border border-secondary rounded mb-4" :noButton="true">
			<template slot="header">
				<h5>Pengecekan Kondisi Mobil - Kanan</h5>
			</template>
			<div class="row mt-3">
				<div class="col-sm-4 col-lg-2 col-12 label-car-type">
					<label>Pilih Jenis Kendaraan :</label>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'sedan', 'btn-outline-info' : carTypes != 'sedan'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'sedan'"
							disabled
						>
							Sedan
						</button>
				</div>
				<div class="col-sm-3 col-lg-2 col-6">
					<button 
							class="btn w-100" 
							:class="{'btn-info' : carTypes == 'minibus', 'btn-outline-info' : carTypes != 'minibus'}" 
							style="border-radius:50px" type="button"
							@click="carTypes = 'minibus'"
							disabled
						>
							Minibus
						</button>
				</div>
			</div>
			

			<div class="row mt-2">
				<!-- <div class="col-md-9 col-sm-12 col-12 " style="overflow-x:scroll">
					<div class="workOrderParent" :class="{'workOrderOuterRightSedan' : carType == 'sedan', 'workOrderOuterRightMinibus' : carType == 'minibus'}">
						<div v-if="carType == 'sedan'" class="workOrderInnerRightSedan">
							<div class="rodaDepanRightSedan" v-on:click="selectPart('right.rodaDepanKanan' , carType)" :class="{'rodaDepanRightSedanActive' : data.condition.figure.sedan.right.rodaDepanKanan.desc != ''}">
							</div>
							<div class="rodaBelakangRightSedan" v-on:click="selectPart('right.rodaBelakangKanan' , carType)" :class="{'rodaBelakangRightSedanActive' : data.condition.figure.sedan.right.rodaBelakangKanan.desc != ''}">
							</div>
							<div class="fenderDepanRightSedan" v-on:click="selectPart('right.fenderDepanKanan' , carType)" :class="{'fenderDepanRightSedanActive' : data.condition.figure.sedan.right.fenderDepanKanan.desc != ''}">
							</div>
							<div class="fenderBelakangRightSedan" v-on:click="selectPart('right.fenderBelakangKanan' , carType)" :class="{'fenderBelakangRightSedanActive' : data.condition.figure.sedan.right.fenderBelakangKanan.desc != ''}">
							</div>
							<div class="kacaDepanRightSedan" v-on:click="selectPart('right.kacaDepanKanan' , carType)" :class="{'kacaDepanRightSedanActive' : data.condition.figure.sedan.right.kacaDepanKanan.desc != ''}">
							</div>
							<div class="kacaBelakangRightSedan" v-on:click="selectPart('right.kacaBelakangKanan' , carType)" :class="{'kacaBelakangRightSedanActive' : data.condition.figure.sedan.right.kacaBelakangKanan.desc != ''}">
							</div>
							<div class="kacaMiniBelakangRightSedan" v-on:click="selectPart('right.kacaMiniBelakangKanan' , carType)" :class="{'kacaMiniRightBelakangSedanActive' : data.condition.figure.sedan.right.kacaMiniBelakangKanan.desc != ''}">
							</div>
							<div class="pintuDepanRightSedan" v-on:click="selectPart('right.pintuDepanKanan' , carType)" :class="{'pintuDepanRightSedanActive' : data.condition.figure.sedan.right.pintuDepanKanan.desc != ''}">
							</div>
							<div class="pintuBelakangRightSedan" v-on:click="selectPart('right.pintuBelakangKanan' , carType)" :class="{'pintuBelakangRightSedanActive' : data.condition.figure.sedan.right.pintuBelakangKanan.desc != ''}">
							</div>
							<div class="sideSkirtRightSedan" v-on:click="selectPart('right.sideSkirtKanan' , carType)" :class="{'sideSkirtRightSedanActive' : data.condition.figure.sedan.right.sideSkirtKanan.desc != ''}">
							</div>
							<div class="sideRoofRightSedan" v-on:click="selectPart('right.sideRoofKanan' , carType)" :class="{'sideRoofRightSedanActive' : data.condition.figure.sedan.right.sideRoofKanan.desc != ''}">
							</div>

						</div>	
						<div v-else class="workOrderInnerRightMinibus">
							<div class="rodaDepanRightMinibus" v-on:click="selectPart('right.rodaDepanKanan' , carType)" :class="{'rodaDepanRightMinibusActive' : data.condition.figure.minibus.right.rodaDepanKanan.desc != ''}">
							</div>
							<div class="rodaBelakangRightMinibus" v-on:click="selectPart('right.rodaBelakangKanan' , carType)" :class="{'rodaBelakangRightMinibusActive' : data.condition.figure.minibus.right.rodaBelakangKanan.desc != ''}">
							</div>
							<div class="fenderDepanRightMinibus" v-on:click="selectPart('right.fenderDepanKanan' , carType)" :class="{'fenderDepanRightMinibusActive' : data.condition.figure.minibus.right.fenderDepanKanan.desc != ''}">
							</div>
							<div class="fenderBelakangRightMinibus" v-on:click="selectPart('right.fenderBelakangKanan' , carType)" :class="{'fenderBelakangRightMinibusActive' : data.condition.figure.minibus.right.fenderBelakangKanan.desc != ''}">
							</div>
							<div class="kacaDepanRightMinibus" v-on:click="selectPart('right.kacaDepanKanan' , carType)" :class="{'kacaDepanRightMinibusActive' : data.condition.figure.minibus.right.kacaDepanKanan.desc != ''}">
							</div>
							<div class="kacaBelakangRightMinibus" v-on:click="selectPart('right.kacaBelakangKanan' , carType)" :class="{'kacaBelakangRightMinibusActive' : data.condition.figure.minibus.right.kacaBelakangKanan.desc != ''}">
							</div>
							<div class="kacaPalingBelakangRightMinibus" v-on:click="selectPart('right.kacaPalingBelakangKanan' , carType)" :class="{'kacaPalingBelakangRightMinibusActive' : data.condition.figure.minibus.right.kacaPalingBelakangKanan.desc != ''}">
							</div>
							
							<div class="kacaMiniDepanRightMinibus" v-on:click="selectPart('right.kacaMiniDepanKanan' , carType)" :class="{'kacaMiniDepanRightMinibusActive' : data.condition.figure.minibus.right.kacaMiniDepanKanan.desc != ''}">
							</div>
							<div class="pintuDepanRightMinibus" v-on:click="selectPart('right.pintuDepanKanan' , carType)" :class="{'pintuDepanRightMinibusActive' : data.condition.figure.minibus.right.pintuDepanKanan.desc != ''}">
							</div>
							<div class="pintuBelakangRightMinibus" v-on:click="selectPart('right.pintuBelakangKanan' , carType)" :class="{'pintuBelakangRightMinibusActive' : data.condition.figure.minibus.right.pintuBelakangKanan.desc != ''}">
							</div>
							<div class="sideSkirtRightMinibus" v-on:click="selectPart('right.sideSkirtKanan' , carType)" :class="{'sideSkirtRightMinibusActive' : data.condition.figure.minibus.right.sideSkirtKanan.desc != ''}">
							</div>
							<div class="sideRoofRightMinibus" v-on:click="selectPart('right.sideRoofKanan' , carType)" :class="{'sideRoofRightMinibusActive' : data.condition.figure.minibus.right.sideRoofKanan.desc != ''}">
							</div>
						</div>							
					</div>
				</div> -->

				<div class="col-12 p-10" style="overflow-x:scroll">

					

					
					<div class="workOrderParent" :class="{'workOrderOuterRightSedan' : carType == 'sedan', 'workOrderOuterRightMinibus' : carType == 'minibus'}" v-if="!exit" >
							

						<template v-if="carType == 'sedan'">
							<div class="workOrderInnerRightSedan h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerRightSedan h-100 w-100"  id="canvasSedan" style="z-index:50;" >
								
							</canvas>
						</template>
						<template v-else>
							<div class="workOrderInnerRightMinibus h-100 w-100" style="z-index:100"  @mousedown="(e) => {this.addShape(e , null)}">
							</div>
							<canvas class="workOrderInnerRightMinibus h-100 w-100"  id="canvasMinibus" style="z-index:50;" >
								
							</canvas>
						</template>
							
						
					</div>
					<div v-else>
							<img v-if="imageSrc" :src="env.baseImage + '/' + imageSrc"  class="workOrderParent"/>

							<div v-else class="mt-5 mb-5 text-center">
								<h2>Tidak Melakukan Tanda Terima</h2>
							</div>

					</div>

					<!-- <img v-if="canvasResult" :src="canvasResult" /> -->
					
					
				</div>
				<div class="col-12 row mt-1 mb-5" v-if="!exit">
					<div class="col-12 mb-2 pl-4 mt-2">
						<label>Pilih Kondisi Berikut untuk Menandai Mobil</label>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-green' : curShape == 'Boncel' , 'btn-outline-secondary' : curShape != 'Boncel'}" class="btn w-100" @click="curShape = 'Boncel'"><i class="fa fa-circle fa-lg mr-2 color-green"></i> Boncel</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-blue' : curShape == 'Baret' , 'btn-outline-secondary' : curShape != 'Baret'}" class="btn w-100" @click="curShape = 'Baret'"><i class="fa fa-circle fa-lg mr-2 color-blue"></i> Baret</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-yellow' : curShape == 'Penyok' , 'btn-outline-secondary' : curShape != 'Penyok'}" class="btn w-100" @click="curShape = 'Penyok'"><i class="fa fa-circle fa-lg mr-2 color-yellow"></i> Penyok</button>
					</div>
					<div class="col-sm-3 col-lg-2 pl-4 mt-2">
						<button :class="{'btn-red' : curShape == 'Pecah' , 'btn-outline-secondary' : curShape != 'Pecah'}" class="btn w-100" @click="curShape = 'Pecah'"><i class="fa fa-circle fa-lg mr-2 color-red"></i> Pecah</button>
					</div>
					<div class="col-sm-4 col-12 offset-lg-2 col-lg-2 pl-4 text-right mt-2">
						<button class="btn btn-danger w-100" @click="reset">Reset</button>
					</div>
						
				</div>
				<div class="col-12" >
					<h4 class="text-center">Kondisi {{carTypes.charAt(0).toUpperCase() + carTypes.slice(1)}}</h4>
					<hr>
					<div class="row">
						<div class="col-4" v-for="checklistCar in Object.keys(data.condition.figure[carTypes].right)" :key="checklistCar" @click="selectPart(`right.${checklistCar}` , carTypes)">
							<div class="row mt-2" >
								<div class="col-6">
									<p>{{translatePart(checklistCar).split(/(?=[A-Z])/).join(' ')}}</p>
									
								</div>
								<div class="col-6 text-center">
									<input type="checkbox" disabled  v-model="data.condition.figure[carTypes].right[checklistCar].desc" >
								</div>
							</div>
							<p v-if="exit && data.condition.figure[carTypes].right[checklistCar].desc != ''" style="font-weight:bold">Deskripsi Rusak : <br>{{data.condition.figure[carTypes].right[checklistCar].desc}}</p>
							<template v-else-if="exit">
								<div class="mt-5"></div>
							</template>
							<hr style="margin-top:5px;margin-bottom:5px;">
						</div>
					</div>
				</div>
				
			</div>
			
		</panel>

		<div class="row">
			<div class="col-md-6 col-0">
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-danger w-100 rounded" @click="$emit('backPage');">Sebelumnya</button>
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-primary w-100 rounded" @click="nextPage" :disabled="apiLoading">Berikutnya</button>
			</div>
		</div>

		<modalUploadImage :varHeader="partHeader" :var="part" :part="translatePart(part)" @showModalFalse="showModal = false" v-if="showModal" @uploadImage="uploadImage"/>
		<modalUploadImageCheckList :var="part" @showModalFalse="showCheckListModal = false" v-if="showCheckListModal" @uploadImage="modalUploadImageCheckList"/>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import modalUploadImage from './modalUploadImage'
	import moment from 'moment'
	import modalUploadImageCheckList from './modalUploadImageChecklist.vue'
	import env from '@/env'

	export default {
		components: {
			Multiselect,
			modalUploadImage,
			modalUploadImageCheckList

		},
		data () {
			return {
				env,
				showModal: false,
				part: '',
				partHeader : '',
				showFrontModal: false,
				carTypes : this.carType,
				checkSettings : this.data.condition.checklist,
				checkSettingsFormatted : null,
				showCheckListModal : false,
				curShape : 'Boncel',
				listOfPoints : [],
				gridMap : null,
				gridMapMinibus : null,
				imageSrc : null,
				canvasResult : null
			}
		},
		props: ['page', 'data', 'checklistSettings' , 'carType', 'title' , 'exit' , 'previousCheckingCondition', 'apiLoading'],
		mounted () {
			this.loadGridCanvas()

			if(this.exit)
				this.imageSrc = this.previousCheckingCondition.condition.figureOverall.right.image.length > 0 
				&& this.previousCheckingCondition.condition.figureOverall.right.image[0] != 'test image'? 
					this.previousCheckingCondition.condition.figureOverall.right.image[0]
					: null

			if(this.exit) {
				let keys = Object.keys(this.data.condition.figure[this.carType].right)
				console.log(this.previousCheckingCondition.condition.figure.right);

				for(var i = 0 ; i < keys.length ; i++) {
					let nowCondition = this.data.condition.figure[this.carType].right[keys[i]]
					let prevCondition = this.previousCheckingCondition.condition.figure.right[keys[i]]
					if(prevCondition.desc != '') {
						nowCondition.desc = prevCondition.desc
						console.log(nowCondition)
					}
				}
			}
			// this.seperate()
		},
		methods: {
			async loadGridCanvas() {
				let col = [97, 7, 50, 14, 31, 9, 97, 10, 6, 156, 7, 5, 9, 94, 8, 81];
				let row = [7, 12, 15, 32, 7, 8, 32, 2, 7, 53, 11, 30];

				let  obj = [{
					name : 'right.rodaDepanKanan',
					startCol : 14,
					endCol  : 15,
					startRow : 10 , 
					endRow : 13
				}, {
					name : 'right.fenderDepanKanan',
					startCol : 13,
					endCol  : 16,
					startRow : 8 , 
					endRow : 12
				},{
					name : 'right.fenderBelakangKanan',
					startCol : 2,
					endCol  : 7,
					startRow : 8 , 
					endRow : 12
				}, {
					name : 'right.kacaDepanKanan',
					startCol : 9,
					endCol  : 11,
					startRow : 3 , 
					endRow : 7
				}, {
					name : 'right.kacaBelakangKanan',
					startCol : 7,
					endCol  : 8,
					startRow : 3 , 
					endRow : 6
					
				}, {
					name : 'right.kacaMiniBelakangKanan',
					startCol : 5,
					endCol  : 7,
					startRow : 4 , 
					endRow : 5
				}, {
					name : 'right.pintuDepanKanan',
					startCol : 8,
					endCol  : 13,
					startRow : 3 , 
					endRow : 11
				},{
					name : 'right.pintuBelakangKanan',
					sstartCol : 4,
					endCol  : 10,
					startRow : 3 , 
					endRow : 11
				}, {
					name : 'right.sideSkirtKanan',
					startCol : 7,
					endCol  : 13,
					startRow : 11 , 
					endRow : 12
				}, {
					name : 'right.sideRoofKanan',
					startCol : 2,
					endCol  : 12,
					startRow : 2 , 
					endRow : 6
				}, {
					name : 'right.rodaBelakangKanan', 
					startCol : 3,
					endCol  : 6,
					startRow : 10 , 
					endRow : 13
				}]

				let colMinibus = [3, 57, 7, 17, 73, 5, 18, 4, 10, 129, 9, 12, 6, 114, 15, 3, 2, 2, 7, 30, 60, 7, 19]
				let rowMinibus = [3, 10, 13, 2, 8, 36.5, 3, 13, 10, 5, 50, 15, 52, 11, 2, 33]

				let objMinibus = [{
					name : 'right.rodaDepanKanan',
					startCol : 20,
					endCol  : 23,
					startRow : 13 , 
					endRow : 17
				},{
					name : 'right.rodaBelakangKanan',
					startCol : 5,
					endCol  : 8,
					startRow : 13 , 
					endRow : 17
				},{
					name : 'right.fenderDepanKanan',
					
					startCol : 16,
					endCol  : 24,
					startRow : 12 , 
					endRow : 16
				},{
					name : 'right.fenderBelakangKanan',
					startCol : 4,
					endCol  : 10,
					startRow : 12 , 
					endRow : 16
				},{
					name : 'right.kacaDepanKanan',
					startCol : 14,
					endCol  : 15,
					startRow : 6 , 
					endRow : 10
				},{
					name : 'right.kacaBelakangKanan',
					startCol : 8,
					endCol  : 11,
					startRow : 4 , 
					endRow : 9
				},{
					name : 'right.kacaPalingBelakangKanan',
					startCol : 3,
					endCol  : 7,
					startRow : 5 , 
					endRow : 8
				},{
					name : 'right.kacaMiniDepanKanan',
					startCol : 16,
					endCol  : 21,
					startRow : 7 , 
					endRow : 11
				},{
					name : 'right.pintuDepanKanan',
					startCol : 12,
					endCol  : 18,
					startRow : 4 , 
					endRow : 14
				},{
					name : 'right.pintuBelakangKanan',
					startCol : 6,
					endCol  : 13,
					startRow : 3 , 
					endRow : 14
				},{
					name : 'right.sideSkirtKanan',
					startCol : 10,
					endCol  : 19,
					startRow : 14 , 
					endRow : 16
				},{
					name : 'right.sideRoofKanan',
					startCol : 2,
					endCol  : 23,
					startRow : 2 , 
					endRow : 11
				}]

				this.gridMap = await this.mapGridCanvas(col , row , obj)
				this.gripMapMinibus = await this.mapGridCanvas(colMinibus , rowMinibus , objMinibus)
			},
			async mapGridCanvas(col , row , obj) {

				for(var i = 0 ; i < obj.length ; i++) {
					let curObj = obj[i]
					curObj.startColLength= col.slice(0 , curObj.startCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endColLength = col.slice(0, curObj.endCol - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.startRowLength= row.slice(0 , curObj.startRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					curObj.endRowLength = row.slice(0, curObj.endRow - 1).reduce((partial_sum, a) => partial_sum + a, 0)
					// console.log(curObj.startColLength , curObj.endColLength , curObj.startRowLength , curObj.endRowLength , curObj.name)
				}
				return obj
			},
			addShape(e = null ,click) {
				if(!e) {
					this.listOfPoints.length = 0
					// this.selected.length = 0
				}
				else {
					let x = 0
					let y = 0

					x = e.offsetX
					y = e.offsetY

					let selectedGrid = this.carTypes == 'sedan' ? this.gridMap : this.gripMapMinibus

					let area = selectedGrid.filter(z => 
						z.startColLength <=  x &&
						z.endColLength >= x &&
						z.startRowLength <= y &&
						z.endRowLength >= y
					)

					if(area.length > 0) {
						// this.selected.push(area.name)
						
						if(area.length == 1)
							this.data.condition.figure[this.carTypes].right[area[0].name.split('.')[1]] = {
								desc : this.curShape
							}
						else {
							let res = []

							for(var i = 0 ; i < area.length ; i++) {
								let z = area[i]
								res[i] = (z.endColLength - x) + (z.endRowLength - y)
								// console.log(z.name , res[i])
							}

							var max = Math.min(...res)
							let index = res.indexOf(max)
							// console.log(area[index] , max)

							

							// this.selectPart(area[index].name , this.carTypes)
							this.data.condition.figure[this.carTypes].right[area[index].name.split('.')[1]] = {
								desc : this.curShape
							}
						}
					}
					this.listOfPoints.push({x , y , shape : this.curShape})
				}
				// console.log(click)
				let canvas = null
				let context = null

				if(this.carTypes == 'sedan') {
					canvas = document.getElementById('canvasSedan');
					context = canvas.getContext('2d');
					canvas.width = 681
					canvas.height = 489.27
				}
				else {
					canvas = document.getElementById('canvasMinibus');
					context = canvas.getContext('2d');
					canvas.width = 633.354
					canvas.height = 316.667
				}

				for(var i = 0 ; i < this.listOfPoints.length ; i++) {
					context.beginPath();
					
					let x = this.listOfPoints[i].x
					let y = this.listOfPoints[i].y

					let fillStyle = '';

					if(this.listOfPoints[i].shape == 'Boncel')
						fillStyle = '#29BC53'
					else if(this.listOfPoints[i].shape == 'Penyok')
						fillStyle = '#FFDD05'
					else if(this.listOfPoints[i].shape == 'Baret')
						fillStyle = '#007ED9'
					else if(this.listOfPoints[i].shape == 'Pecah')
						fillStyle = '#FF0000'

					// console

					context.moveTo( this.listOfPoints[i].x + 7.5, this.listOfPoints[i].y );
					context.arc(this.listOfPoints[i].x, this.listOfPoints[i].y, 7.5 ,2*Math.PI,0 *Math.PI);
					context.fillStyle = fillStyle;
					context.fill();
					context.stroke();
				}
				// var dataURL = canvas.toDataURL();
				// console.log(dataURL)
				
				
			},
			reset() {
				this.addShape(null)

				this.data.condition.figureOverall[this.carTypes].right = { image : [] }
				let keys = Object.keys(this.data.condition.figure[this.carTypes].right)
				// console.log(keys)

				for(var i = 0 ; i < keys.length ; i++) {
					this.data.condition.figure[this.carTypes].right[keys[i]] = { desc : '' }
				}
			},
			translatePart (str) {
				let strSplit = str.split("_").reverse()

				for (var i = 0 ; i < strSplit.length ; i ++) {
					
					if(strSplit[i] == 'front')
						strSplit[i] = 'depan'
					else if (strSplit[i] == 'rear')
						strSplit[i] = 'belakang'
					else if (strSplit[i] == 'left')
						strSplit[i] = 'kiri'
					else if (strSplit[i] == 'right')
						strSplit[i] = 'kanan'
					else if (strSplit[i] == 'wheel')
						strSplit[i] = 'roda'
					else if (strSplit[i] == 'door')
						strSplit[i] = 'pintu'
					else if (strSplit[i] == 'light')
						strSplit[i] = 'lampu'
					else if (strSplit[i] == 'car')
						strSplit[i] = 'mobil'
					else if (strSplit[i] == 'window')
						strSplit[i] = 'kaca'

					strSplit[i] = strSplit[i].charAt(0).toUpperCase() + strSplit[i].slice(1)
				}

				return strSplit.join(" ")
			},
			uploadImage (partHeader , part, url) {
				if(partHeader != 'figureOverall')
					this.data.condition[partHeader][this.carTypes].front[part] = url
				else 
					this.data.condition[partHeader][this.carTypes][part] = url
				// alert("Unggah Gambar Berhasil!")

				this.$store.dispatch('triggerAlert', [true, ['Unggah Gambar Berhasil']])
				this.showModal = false

				if(partHeader == 'figureOverall')
					this.$emit('nextPage')
			},
			nextPage () {
				if(this.data.condition.figureOverall[this.carTypes].right.image.length > 1) {
					this.$emit('nextPage')
				}

				if(this.exit) {
					this.showModal = true;
					this.part = 'right'
					this.partHeader = 'figureOverall'
					return
				}
				var destinationCanvas = document.createElement("CANVAS");
				var destCtx = destinationCanvas.getContext('2d');

				var background = new Image();
				let canvasId = this.carTypes == 'sedan' ? 'canvasSedan' : 'canvasMinibus'
				let param = {}

				if(this.carTypes == 'sedan') {
					destinationCanvas.width = 690
					destinationCanvas.height = 489.27
					
					background.src = "/img/WorkOrder/Sedan/CAMRY RIGHT.svg";
					param.width = 680
					param.height = 250
					param.offsetX = 0
					param.offsetY = 60
					param.canvasX = 0
					param.canvasY = 68
				}
				else {
					destinationCanvas.width = 725
					destinationCanvas.height = 385
					
					background.src = "/img/WorkOrder/Minibus/ALPHARD RIGHT.svg";
					param.width = 690
					param.height = 265
					param.offsetX = 23.5
					param.offsetY = 60
					param.canvasX = 55
					param.canvasY = 60
				}

				let vm = this
				background.onload = async function(){

					destCtx.drawImage(background, param.offsetX , param.offsetY , param.width , param.height );   
					const canvas = document.getElementById(canvasId);
					// console.log(canvas.toDataURL())
				

					destCtx.drawImage(canvas, param.canvasX ,  param.canvasY);

					let modifiedFile = vm.dataURLtoFile(destinationCanvas.toDataURL() , 'image.jpg')
					// console.log(destinationCanvas.toDataURL())
					vm.canvasResult = destinationCanvas.toDataURL()
					
					let formData = new FormData()

					formData.append('work_order' , modifiedFile)
					
					
					try {
						let url = env.urlStart + "/api/v1/workorder/image"
						let response = await vm.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
						let data = response.data.data
						
						vm.data.condition.figureOverall[vm.carTypes].right = {
							image : [data.filename]
						}
						vm.$emit('nextPage')
					}   catch (err) {
						vm.$store.dispatch('triggerAlert' , [false , ['Something Went Wrong. Please Try Again Later.' , err]])
						console.log(err)
					}       
				}
			}
		}
	}
</script>

<style scoped>
	.workOrderParent {
		overflow-y: hidden;
	}

	.color-green {
		color : #29BC53;
	}
	.color-blue {
		color : #007ED9;
	}
	.color-yellow {
		color : #FFDD05;
	}
	.color-red {
		color : #FF0000;
	}

	.btn {
		border-radius: 30px;
		border : 0.5px solid;
	}

	.btn-green {
		background-color: #29BC5326;
		color : black;
	}

	.btn-blue {
		background-color: #007ED926;
		color : black;
	}
	.btn-yellow {
		background-color: #FFDD0526;
		color : black;
	}
	.btn-red {
		background-color: #FF000026;
		color : black;
	}

	.label-car-type {
		display: flex;
		align-items: center;
		letter-spacing: 0.015em;
		font-size: 14px;
	}
</style>
